import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { UserService } from '../service/user.service';

export const AdminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  // On a full page reload the logged user is not loaded yet, so the check must be
  // asynchronous: wait for MSAL to settle (active account available) and then resolve the user.
  return msalBroadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    take(1),
    switchMap(() => userService.ensureLoggedUser()),
    map((user) => {
      if (user && user.isAdmin) {
        return true;
      }

      router.navigate(['/my-catalog']);
      return false;
    }),
    catchError((error) => {
      console.error('Error checking admin permission:', error);
      router.navigate(['/my-catalog']);
      return of(false);
    })
  );
};
